<template>
  <div class="application-gallery mb-5 mb-lg-0">
    <LightBox :images="gallery.topGallery" :slideIndex="topGalleryIndex" :targetId="targetId" v-if="targetId"/>
    <vueper-slides
        ref="healthcareTopRef"
        class="top-gallery"
        :slide-ratio="1 / 4"
        :bullets="false"
        :arrows="false"
        :dragging-distance="50"
        prevent-y-scroll
        @slide="$refs.healthcareBottomRef && $refs.healthcareBottomRef.goToSlide($event.currentSlide.index, { emit: false })"
    >
      <vueper-slide
          v-for="(slide, index) in gallery.topGallery"
          :key="slide.id"
          class="position-relative"
          data-bs-toggle="modal"
          :data-bs-target="'#' + targetId"
          @click="topGalleryIndex = index"
      >
        <template #content>
          <img
              :src="slide.imgLink"
              :alt="slide.altText"
              class="h-100 w-100 fit-cover"
          />
        </template>
      </vueper-slide>
    </vueper-slides>
    <vueper-slides
        ref="healthcareBottomRef"
        class="thumb-gallery"
        :class="{'thumb-gallery-centered': gallery.thumbsGallery.length <= 3}"
        gap="2"
        :slide-ratio="1 / 8"
        :dragging-distance="10"
        :visible-slides="4"
        :arrows="true"
        :bullets="false"
        :breakpoints="breakpoints"
        @slide="$refs.healthcareTopRef && $refs.healthcareTopRef.goToSlide($event.currentSlide.index, { emit: false })"

    >
      <vueper-slide
          v-for="(thumb, index) in gallery.thumbsGallery"
          :key="thumb.id"
          @click.native="$refs.healthcareBottomRef.goToSlide(index )">
          >
        <template #content>
            <img
                :src="thumb.imgLink"
                :alt="thumb.altText"
                class="h-100 w-100 fit-cover"
                draggable="false"
            />
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'

import ButtonRed from "@/components/common/ButtonRed";
import LightBox from "@/components/common/modals/LightBox";

export default {
  components: { VueperSlides, VueperSlide, ButtonRed, LightBox },
  data: () => ({
    breakpoints: {
      576: {
        visibleSlides: 3
      },
      992: {
        visibleSlides: 5
      },
      1200: {
        visibleSlides: 4
      },
    },
    topGalleryIndex: 0,
  }),
  props: {
    gallery: {
      topGallery: Array,
      thumbsGallery: Array
    },
    targetId: String
  },
}
</script>
